var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-img',{attrs:{"src":_vm.skin === 'light' ? _vm.appLogoImage : _vm.appLogoImageDark,"alt":_vm.appName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }